<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm1"></a></p>
<div class="fmhT">OTHER BOOKS IN THE REUBEN/RIFKIN SERIES</div>
<div> <br/></div><div class="ctag1"><i>Arguing with the Storm: Stories by Yiddish Women Writers</i><br/> edited by Rhea Tregbov</div>
<div> <br/></div><div class="ctag1"><i>Dearest Anne: A Tale of Impossible Love</i><br/> by Judith Katzir</div>
<div> <br/></div><div class="ctag1"><i>Dream Homes: From Cairo to Katrina, an Exile’s Journey</i><br/> by Joyce Zonana</div>
<div> <br/></div><div class="ctag1"><i>Shalom India Housing Society</i><br/> by Esther David</div>
<div> <br/></div><div class="ctag1"><b>The Reuben/Rifkin Jewish Women Writers Series A joint project of the Hadassah-Brandeis Institute and the Feminist Press</b></div>
<div> <br/></div><div class="ctag1"><i>Series editors: Elaine Reuben, Shulamit Reinharz, Gloria Jacobs</i></div>
<div> <br/></div><div class="ctag1">The Reuben/Rifkin Jewish Women Writers Series, established in 2006 by Elaine Reuben, honors her parents, Albert G. and Sara I. Reuben. It remembers her grandparents, Susie Green and Harry Reuben, Bessie Goldberg and David Rifkin, known to their parents by Yiddish names, and recalls family on several continents, many of whose names and particular stories are now lost. Literary works in this series, embodying and connecting varieties of Jewish experiences, will speak for them, as well, in the years to come.</div>
<div> <br/></div><div class="ctag1">Founded in 1997, the Hadassah-Brandeis Institute (HBI), whose generous grants also sponsor this series, develops fresh ways of thinking about Jews and gender worldwide by producing and promoting scholarly research and artistic projects. Brandeis professors Shulamit Reinharz and Sylvia Barack Fishman are the founding director and codirector, respectively, of HBI.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// jenn_9781558616912_oeb_fm1_r1.vue?3dc7c701